import { Suspense } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Header from "../../components/Header/Header";
import { OverlayLoading } from "../../components/OverlayLoading/OverlayLoading";
import { Unauthorized } from "../../components/PrivateRoute";
import { useAuthentication } from "../../reducer/authentication";
import { isAdminOrSuperAdmin } from "../../utils";
import Tickets from "./Tickets";

//const TechAssisTracking = React.lazy(() => import('./TechAssisTracking'));

export default function SupportRoot() {
    const match = useRouteMatch();
    const { user } = useAuthentication();
    const isAdmin = isAdminOrSuperAdmin(user);
    return (
        <>
            <Header />
            <Suspense fallback={<OverlayLoading loading />}>
                <Switch>
                    <Route path={match.path} exact>
                        <p>Suporte</p>
                    </Route>
                    <Route path={match.path + '/tickets'} component={Tickets} />
                    <Route>
                        <Unauthorized redirectUrl={false} />
                    </Route>
                </Switch>
            </Suspense>
        </>
    )
}
